import React, {useState} from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {LoadingButton} from "@mui/lab";
import {useSearchParams} from "react-router-dom";
import {Box, FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import Api from "../Services/Api"
import Result from "./Result/Result";

const UrlChecker = ({ open, setOpen }) => {
    const [loading, setLoading] = useState(false);
    const [url, setUrl] = useState(null);
    const [device, setDevice] = useState("d");
    const [country, setCountry] = useState("US");
    const [source, setSource] = useState("tb");
    const [data, setData] = useState(null);
    let [searchParams, setSearchParams] = useSearchParams();

    const handleClose = () => {
        setOpen(false);
    };

    const handleCheck = (e) => {
        e.preventDefault();
        setData(null);
        setLoading(true);
        Api.checker({ url: url, device: device, cc: country.toLowerCase(), ref: source })
            .then(r => {
                setData(r);
                setLoading(false);
            });
    };
    

    return (
        <Dialog open={open} onClose={handleClose} maxWidth={"md"} fullWidth>
            <DialogTitle>Check Url</DialogTitle>
            <DialogContent>
                {!searchParams.get('data') && <div>
                    <DialogContentText>
                        Please enter the tracking url that you want to check. It can take some time. Be Patient.
                    </DialogContentText>
                    <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                        <FormControl sx={{ minWidth: 120 }}>
                            <InputLabel id="device">Device</InputLabel>
                            <Select
                                labelId="Device"
                                id="device"
                                value={device ?? ''}
                                label="Device"
                                onChange={(event) => setDevice(event.target.value)}
                            >
                                <MenuItem value={"m"}>Mobile</MenuItem>
                                <MenuItem value={"d"}>Desktop</MenuItem>
                            </Select>
                        </FormControl>
                        
                        <FormControl sx={{ minWidth: 120 }}>
                            <InputLabel id="source">Source</InputLabel>
                            <Select
                                labelId="source"
                                id="source"
                                value={source}
                                label="Source"
                                onChange={(event) => setSource(event.target.value)}
                            >
                                <MenuItem value="tb">Taboola</MenuItem>
                                <MenuItem value="ob">Outbrain</MenuItem>
                                <MenuItem value="fb">Facebook</MenuItem>
                                <MenuItem value="nr">No Ref</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl sx={{ minWidth: 120 }}>
                            <InputLabel id="country">Country</InputLabel>
                            <Select
                                labelId="country"
                                id="country"
                                value={country}
                                label="Country"
                                onChange={(event) => setCountry(event.target.value)}
                            >
                                <MenuItem value="US">United States</MenuItem>
                                <MenuItem value="GB">United Kingdom</MenuItem>
                                <MenuItem value="CA">Canada</MenuItem>
                                <MenuItem value="AU">Australia</MenuItem>
                                <MenuItem value="DE">Germany</MenuItem>
                                <MenuItem value="FR">France</MenuItem>
                                <MenuItem value="IT">Italy</MenuItem>
                                <MenuItem value="ES">Spain</MenuItem>
                                <MenuItem value="JP">Japan</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                    <form onSubmit={handleCheck}>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="url"
                            label="Tracking Url"
                            type="url"
                            value={url ?? ''}
                            fullWidth
                            variant="standard"
                            onChange={(event) => setUrl(event.target.value)}
                        />
                        {loading ?
                            <LoadingButton loading variant="outlined" sx={{ mt: 1 }}>
                                Submit
                            </LoadingButton> :
                            <Button type={"submit"} variant={"outlined"} sx={{ mt: 1 }} disabled={!url}>Check</Button>}
                    </form>
                </div>}
                {data && <Result data={data}/>}
            </DialogContent>
        </Dialog>
    );
};

export default UrlChecker;
